export const MOBILE_TOOLBAR_TOTAL = 80;
